module.exports = __webpack_public_path__ + "static/media/youtubebw.db334b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/youtubebw.svg
// module id = 2072
// module chunks = 118